module.exports = __webpack_public_path__ + "img/twitter_logo.84ab3f46.png";